/** Canonical marketplace + customer account URLs */
export const MARKET = {
  HOME: "/market",
  SEARCH: "/market/search",
  SELL: "/market/sell",
  CART: "/market/cart",
  CART_EMPTY: "/market/cart/empty",
  CHECKOUT: "/market/checkout",
  PAYMENT_VERIFICATION: "/market/payment-verification",
  ORDER_CONFIRMATION: "/market/order-confirmation/:orderId",
  PRODUCT: "/market/product/:slug",
  STORE: "/market/store/:merchantId",
  RETURN_POLICY: "/market/return-policy",
  TRACK_ORDER: "/market/track-order",
  DEALS_TRENDING: "/market/deals/trending",
  DEALS_TODAY: "/market/deals/today",
  DEALS_TOP_SELLING: "/market/deals/top-selling",
  DEALS_RECOMMENDED: "/market/deals/recommended",
  CATEGORY_SUPERMARKET: "/market/category/supermarket",
  CATEGORY_HEALTH_BEAUTY: "/market/category/health-beauty",
  CATEGORY_HOME_OFFICE: "/market/category/home-office",
  CATEGORY_APPLIANCES: "/market/category/appliances",
  CATEGORY_PHONES_TABLETS: "/market/category/phones-tablets",
  CATEGORY_COMPUTING: "/market/category/computing",
  CATEGORY_ELECTRONICS: "/market/category/electronics",
  CATEGORY_FASHION: "/market/category/fashion",
  CATEGORY_BABY_KIDS: "/market/category/baby-kids",
  CATEGORY_GAMING: "/market/category/gaming",
  CATEGORY_SPORTING: "/market/category/sporting-goods",
  CATEGORY_GROCERY: "/market/category/grocery",
  CATEGORY_KITCHEN: "/market/category/kitchen",
  CATEGORY_BUILDING: "/market/category/building-materials",
};

export const ACCOUNT = {
  HOME: "/account",
  ORDERS: "/account/orders",
  ORDER_DETAIL: "/account/orders/:orderId",
  SAVED: "/account/saved",
  INBOX: "/account/inbox",
  RECENT: "/account/recent",
  REVIEWS: "/account/reviews",
  ADDRESSES: "/account/addresses",
  SETTINGS: "/account/settings",
};

export const getProductPath = (product) => {
  if (!product) return MARKET.HOME;
  const slug = product.slug || product._id;
  return slug ? `/market/product/${slug}` : MARKET.HOME;
};

export const getMerchantStorePath = (merchantId) =>
  merchantId ? `/market/store/${merchantId}` : MARKET.HOME;

/** Static legacy path → canonical path (no params) */
export const MARKETPLACE_LEGACY_REDIRECTS = [
  { from: "/Market", to: MARKET.HOME },
  { from: "/MerchantForm", to: MARKET.SELL },
  { from: "/CartListView", to: MARKET.CART },
  { from: "/EmptyCart", to: MARKET.CART_EMPTY },
  { from: "/ShippingDetail", to: MARKET.CHECKOUT },
  { from: "/marketplace/payment-verification", to: MARKET.PAYMENT_VERIFICATION },
  { from: "/search", to: MARKET.SEARCH },
  { from: "/returnpolicy", to: MARKET.RETURN_POLICY },
  { from: "/trackyourorder", to: MARKET.TRACK_ORDER },
  { from: "/UserProfile", to: ACCOUNT.HOME },
  { from: "/customerorder", to: ACCOUNT.ORDERS },
  { from: "/customersaveditem", to: ACCOUNT.SAVED },
  { from: "/customermsginbox", to: ACCOUNT.INBOX },
  { from: "/recentview", to: ACCOUNT.RECENT },
  { from: "/pendingreview", to: ACCOUNT.REVIEWS },
  { from: "/addressbook", to: ACCOUNT.ADDRESSES },
  { from: "/accountmanagement", to: ACCOUNT.SETTINGS },
  { from: "/settings", to: ACCOUNT.SETTINGS },
  { from: "/CustomerChangePass", to: ACCOUNT.SETTINGS },
  { from: "/supermarket", to: MARKET.CATEGORY_SUPERMARKET },
  { from: "/healthbeauty", to: MARKET.CATEGORY_HEALTH_BEAUTY },
  { from: "/homeOffice", to: MARKET.CATEGORY_HOME_OFFICE },
  { from: "/appliance", to: MARKET.CATEGORY_APPLIANCES },
  { from: "/phonestablets", to: MARKET.CATEGORY_PHONES_TABLETS },
  { from: "/computing", to: MARKET.CATEGORY_COMPUTING },
  { from: "/electronics", to: MARKET.CATEGORY_ELECTRONICS },
  { from: "/fashion", to: MARKET.CATEGORY_FASHION },
  { from: "/baby,kidstoy", to: MARKET.CATEGORY_BABY_KIDS },
  { from: "/gaming", to: MARKET.CATEGORY_GAMING },
  { from: "/sportinggoods", to: MARKET.CATEGORY_SPORTING },
  { from: "/grocery", to: MARKET.CATEGORY_GROCERY },
  { from: "/kitchenutensils", to: MARKET.CATEGORY_KITCHEN },
  { from: "/buildingmaterial", to: MARKET.CATEGORY_BUILDING },
  { from: "/alltrendingproducts", to: MARKET.DEALS_TRENDING },
  { from: "/alltodaydealproduct", to: MARKET.DEALS_TODAY },
  { from: "/alltopsellingproduct", to: MARKET.DEALS_TOP_SELLING },
  { from: "/recommendedProduct", to: MARKET.DEALS_RECOMMENDED },
];

export const MARKETPLACE_LISTING_PATHS = [
  MARKET.CATEGORY_SUPERMARKET,
  MARKET.CATEGORY_HEALTH_BEAUTY,
  MARKET.CATEGORY_HOME_OFFICE,
  MARKET.CATEGORY_APPLIANCES,
  MARKET.CATEGORY_PHONES_TABLETS,
  MARKET.CATEGORY_COMPUTING,
  MARKET.CATEGORY_ELECTRONICS,
  MARKET.CATEGORY_FASHION,
  MARKET.CATEGORY_BABY_KIDS,
  MARKET.CATEGORY_GAMING,
  MARKET.CATEGORY_SPORTING,
  MARKET.CATEGORY_GROCERY,
  MARKET.CATEGORY_KITCHEN,
  MARKET.CATEGORY_BUILDING,
  MARKET.DEALS_TRENDING,
  MARKET.DEALS_TODAY,
  MARKET.DEALS_TOP_SELLING,
  MARKET.DEALS_RECOMMENDED,
];
